import React, { Component } from 'react';
import { IAttributesBarProps, IAttributesBarState } from './interfaces';
import { FontAwesomeIcon } from "../../../components/ui/FontAwesomeIcon";
import {
  Dropdown,
  Card,
  CardBody,
  CardHeader,
  Collapse,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Popover, Button
} from "reactstrap";
import { CheckBox } from "../../../components/ui/CheckBox";
import { ColumnList } from "./columnsList";
import { WithinSelector } from './withinSelector';


export class AttributesBar extends Component<IAttributesBarProps, IAttributesBarState> {
  state: IAttributesBarState = {
    hierarchyCollapse: true,
    hierarchyCollapseStatus: true,
    columnsCollapse: true,
    columnsCollapseStatus: true,
    rankDropdownOpen: false,
    withinDropdownOpen: false,
    isColumnPopUpOpen: false
  }



  toggleHierarchyCollapse() {
    const { hierarchyCollapse } = this.state;
    this.setState({ hierarchyCollapse: !hierarchyCollapse });
  }

  toggleColumnsCollapse() {
    const { columnsCollapse } = this.state;
    this.setState({ columnsCollapse: !columnsCollapse });
  }

  toggleHierarchyCollapseStatus() {
    const { hierarchyCollapseStatus } = this.state;
    this.setState({ hierarchyCollapseStatus: !hierarchyCollapseStatus });
  }

  toggleColumnsCollapseStatus() {
    const { columnsCollapseStatus } = this.state;
    this.setState({ columnsCollapseStatus: !columnsCollapseStatus });
  }

  toggleRankDropdown() {
    this.setState({ rankDropdownOpen: !this.state.rankDropdownOpen });
  }

  toggleWithinDropdown() {
    this.setState({ withinDropdownOpen: !this.state.withinDropdownOpen });
  }



  render() {
    const { updateRank, updateWithin, toggleShowIndustryAverages, toggleShowRollupAverages, rank, within, rankAvids, isColumnFormPopUpOpen, toggleColumnPopUp, isValidRank, isValidWithin, isValidColumns, withinChildrenOptions } = this.props;

    const withinOptions = (rank && rankAvids.length > 0 ? rankAvids.find((avid) => avid.hierarchy == rank).path : []);

    const hierarchyIcon = (this.state.hierarchyCollapseStatus ? 'angle-down' : 'angle-right');
    const columnsIcon = (this.state.columnsCollapseStatus ? 'angle-down' : 'angle-right');

    return (
      <Card>
        <CardHeader>
          <h5 className='d-flex justify-content-between'>Hierarchy <FontAwesomeIcon icon={hierarchyIcon} onClick={() => this.toggleHierarchyCollapse()} /></h5>
        </CardHeader>
        <Collapse
          isOpen={this.state.hierarchyCollapse}
          onEntered={() => this.toggleHierarchyCollapseStatus()}
          onExited={() => this.toggleHierarchyCollapseStatus()}
        >
          <CardBody>
            <div className="margin-bottom">
              <Dropdown isOpen={this.state.rankDropdownOpen} toggle={() => this.toggleRankDropdown()}>
                {this.props.columns.length > 0 ? (
                  <span className="text-danger">
                    The following settings cannot be edited until all columns in the report have been removed.</span>
                ) : null}
                <DropdownToggle disabled={(this.props.columns.length > 0)} caret outline color='dark'>
                  <p className='d-flex justify-content-between'>
                    <strong>Rank: </strong> {(rank ? rank : 'None Selected')}
                    <span><FontAwesomeIcon icon="caret-down" fixedWidth /></span>
                  </p>
                </DropdownToggle>
                <DropdownMenu className='user-select-dropdown-menu'>
                  <DropdownItem disabled>Select One</DropdownItem>
                  {rankAvids &&
                    rankAvids.map((avid, index) => {
                      if (avid.hierarchy != 'Bankwide') {
                        return (
                          <DropdownItem key={'avid-item' + index} onClick={() => {
                            updateRank(avid.hierarchy)
                          }}>
                            {avid.hierarchy}
                          </DropdownItem>
                        )
                      }
                    })
                  }
                </DropdownMenu>
              </Dropdown>
              <span className={'text-danger ' + (isValidRank ? 'd-none' : '')}>Please select an option</span>
            </div>
            <div className="margin-bottom">
              <Dropdown isOpen={this.state.withinDropdownOpen} toggle={() => this.toggleWithinDropdown()}>
                <DropdownToggle disabled={(this.props.columns.length > 0)} caret outline color='dark'>
                  <p className='d-flex justify-content-between'>
                    <strong>Within: </strong> {(within ? within : 'None Selected')}
                    <span><FontAwesomeIcon icon="caret-down" fixedWidth /></span>
                  </p>
                </DropdownToggle>
                <WithinSelector
                  isOpen={this.state.withinDropdownOpen}
                  updateWithin={(avidID) => updateWithin(avidID)}
                  rankAvids={rankAvids}
                  withinOptions={withinOptions}
                />
              </Dropdown>
              <span className={'text-danger ' + (isValidWithin ? 'd-none' : '')}>Please select an option</span>
            </div>
            <CheckBox
              onChange={() => toggleShowIndustryAverages(!this.props.showIndustryAverages)}
              isEnabled
              isChecked={this.props.showIndustryAverages}
              label='Show Industry Averages' />
            <CheckBox
              onChange={() => toggleShowRollupAverages(!this.props.showRollupAverages)}
              isEnabled
              isChecked={this.props.showRollupAverages}
              label='Show Rollup Averages' />
          </CardBody>
        </Collapse>
        <CardHeader>
          <h5 className='d-flex justify-content-between'>Columns <FontAwesomeIcon icon={columnsIcon} onClick={() => this.toggleColumnsCollapse()} /></h5>
        </CardHeader>
        <Collapse
          isOpen={this.state.columnsCollapse}
          onEntered={() => this.toggleColumnsCollapseStatus()}
          onExited={() => this.toggleColumnsCollapseStatus()}
        >
          <CardBody id='column-edit-section'>
            <ColumnList
              isColumnsPopUpOpen={isColumnFormPopUpOpen}
              updateColumnsOrder={(columnIDs: number[]) => this.props.updateColumnsOrder(columnIDs)}
              toggleColumnPopUp={(isOpen, columnID) => toggleColumnPopUp(isOpen, columnID)}
              reportColumns={this.props.columns}
            />
            <span className={'text-danger ' + (isValidColumns ? 'd-none' : '')}>Please add at least one column</span>
            <div className="text-right">
              <Button color="primary" onClick={() => {
                toggleColumnPopUp(true, undefined);
              }}>Add Column</Button>
              <Button style={{ marginTop: '1rem' }} block color="primary" onClick={() => {
                this.props.runReport()
              }} disabled={!(this.props.columns.length > 0)}>Run Report</Button>
            </div>
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}
